export class RuleOutcome {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "component",
            "baseName": "component",
            "type": "RuleComponent",
            "format": ""
        },
        {
            "name": "passed",
            "baseName": "passed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "expected",
            "baseName": "expected",
            "type": "string",
            "format": ""
        },
        {
            "name": "observed",
            "baseName": "observed",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RuleOutcome.attributeTypeMap;
    }
    constructor() {
    }
}
